<div class="p-inputgroup" *transloco="let t">

  <button
    class="input-wrapper-button"
    (click)="openDialog()"
    [attr.aria-label]="t(placeholder)"
  >
    <div *ngIf="selectedSubjects.length === 0" class="placeholder-text">
      <p [transloco]="placeholder"></p>
    </div>

    <div class="p-chips" aria-hidden="true" *ngIf="selectedSubjects.length > 0">
      <div class="p-chips-multiple-container">
        <ng-container *ngFor="let item of selectedSubjects">
          <bulb-unit-chip [unit]="item"></bulb-unit-chip>
        </ng-container>
      </div>
    </div>
  </button>

  <button
    class="p-inputgroup-addon open-dialog-button"
    type="button"
    (click)="openDialog()"
    [disabled]="disabled"
  >
    <svg-icon [key]="'pencil'" fontSize="1.5rem"></svg-icon>
  </button>
</div>
